// @ts-nocheck
import './App.css'

import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import ProductIntroduction from './pages/home/ProductIntroduction.tsx'

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ProductIntroduction />} />
      </Routes>
    </Router>
  )
}

export default App
